module.exports = __webpack_public_path__ + "img/img-icon-chanpin2-tuya.c7b28825.webp";